<template>
    <div class="sharepoint-image-preview-modal" @click.self="Close">
        <img :src="src" :alt="title" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "Preview"
        },
        src: {
            type: String,
            required: true
        }
    },
    setup(props, context) {
        const Close = () => {
            context.emit("close");
        };

        return {
            Close
        };
    }
};
</script>

<style lang="scss" scoped>
.sharepoint-image-preview-modal {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    background: transparent;
    position: relative;
}

img {
    display: block;
    max-width: 92vw;
    max-height: 88vh;
    object-fit: contain;
    box-shadow: 0 14px 48px rgba(0, 0, 0, 0.32);
}

</style>
